import { createGlobalStore } from 'hox';
import { useState } from 'react';

import { LoginUser } from '../types';
import { MD5 } from 'crypto-js';

function useLoginUser() {
  const [user, setUser] = useState<LoginUser>();

  const setUserWithUpdateRoleName = (user: LoginUser) => {
    if (user.roleName === 'Trend-TMCAS@SuperAdmin') {
      user.roleName = 'superAdministrator';
    } else if (user.roleName === 'Administrator') {
      user.roleName = 'globalAdministrator';
    }
    setUser(user);
  };

  const setUserModifySession = (user: LoginUser) => {
    setUserWithUpdateRoleName(user);
    sessionStorage.setItem('visitor_id', MD5(user.loginEmail).toString());
    sessionStorage.setItem('account_id', user.clpCompanyId);
  };

  const isRootUser = user?.roleName === 'superAdministrator';

  return {
    user,
    setUserModifySession,
    setUser: setUserWithUpdateRoleName,
    isRootUser,
  };
}
export const [useLoginUserStore] = createGlobalStore(useLoginUser);
